//Signed-out ("public") viewing of event agenda pages.
//
//Omerson 10/20/2026: "we want people to see it publicly". learning.clubwealth.com/bsm (and
///bsm2026, where /bsm points) shows the agenda to a visitor with no CWU sign-in instead of
//sending them to /login. Same address for everyone, so clubwealth.com/bsm's row links and the
///bsm short link work for both kinds of visitor; a signed-in member still gets the full app.
//
//In the public view every session tile is greyed out (no account, no ticket), a click on one
//goes to the page's tickets link (the Conferences element's `noPermissionUrl`), and a popup
//offers sign-in (PublicSignInPrompt.js). The tiles come from a public, display-only route:
//InfusionsoftIntegration publicApi/agenda/agenda.js (it allows only its listed categories).
//
//Each event that wants a public agenda adds its page url here AND its category there.
import axios from 'axios';
import DomainInfo from '../../helpers/DomainInfo';

export const PUBLIC_PAGE_PATHS = ['/bsm2026'];

const normalise = (pathname) =>
  (pathname || '').toLowerCase().replace(/\/+$/, '') || '/';

export const isSignedIn = () => {
  try {
    return !!window.localStorage.getItem('CWAuthToken');
  } catch (error) {
    return false;
  }
};

export const isPublicPagePath = (pathname) =>
  PUBLIC_PAGE_PATHS.includes(normalise(pathname));

//True while a signed-out visitor is on a public page (the day tabs inside it included).
export const isPublicView = (pathname = window.location.pathname) =>
  !isSignedIn() && isPublicPagePath(pathname);

//The sessions of one Conferences block, without a sign-in. Display fields only.
export const fetchPublicOccurrences = async (category, ids) => {
  const res = await axios.get(
    `${DomainInfo.baseUrl}/api/public/agenda/occurrences`,
    { params: { category, ids: ids.join() } }
  );
  return res.data;
};
